module.exports = __webpack_public_path__ + "img/akitogogon-2.6b60baae.jpg";